export var AvailabilityState;
(function (AvailabilityState) {
    AvailabilityState["AvailableSoon"] = "AvailableSoon";
    AvailabilityState["OnStock"] = "OnStock";
    AvailabilityState["TemporaryOutOfStock"] = "TemporaryOutOfStock";
    AvailabilityState["OutOfStock"] = "OutOfStock";
    AvailabilityState["Historic"] = "Historic";
    AvailabilityState["PreOrder"] = "PreOrder";
})(AvailabilityState || (AvailabilityState = {}));
//# sourceMappingURL=types.js.map